import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Cargando from '../../components/misc/Redirect/Cargando';
import { getTransacciones } from './Services/transacciones.services';
import { NumericFormat } from 'react-number-format';
import { SUCCESS_GET_TRANSACCIONES } from './utilities/constants';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';


interface IData{
    cierreLote:number
    desc_servicio:string
    montoSinDescuento:string
    monto:string

}
const TransaccionesAgrupadas = () => {
    const [data,setData] = useState<IData[]>([])
    const [loader,setLoader] = useState(false)

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);

    useEffect(()=>{
      (async () => {
          const result = await getTransacciones()
          if(result.status === 200){
            setData(result.data);
            setLoader(true)
          }else{
            setData(result.data);
            setLoader(true)
          }
      })();
  }, [])

  const montoTotalBodyTemplate = (rowData: any) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Monto Total</span>
            <NumericFormat value={rowData.montoSinDescuento} displayType={'text'} thousandSeparator={"."} decimalSeparator={","} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
        </React.Fragment>
    );
}
const montoSDescuentoBodyTemplate = (rowData: any) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Monto Sin Descuento</span>
            <NumericFormat value={rowData.monto} displayType={'text'} thousandSeparator={"."} decimalSeparator={","} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
        </React.Fragment>
    );
}


    

    const onCustomPage2 = (event:any) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }
    
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options:any) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} style={{width:"8%"}}/>
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options:any) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };
  
  return (
    !loader 
    ? <Cargando/> 
    :<div>
        <div className="card">
            
            <DataTable value={data} header="Transacciones Agrupadas" paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                    paginatorClassName="justify-content-end" className="p-mt-6" responsiveLayout="scroll">

                <Column field="cierreLote" header="Cierre de lote"></Column>
                <Column field="desc_servicio" header="Mercaderia"></Column>
                <Column field="montoSinDescuento" header="Monto sin descuento" body={montoSDescuentoBodyTemplate} ></Column>
                <Column field="monto" header="Monto total" body={montoTotalBodyTemplate} ></Column>
            </DataTable>
        </div>
    </div>
);
};

export default TransaccionesAgrupadas;
